import { render, staticRenderFns } from "./resourcePoolSystem.vue?vue&type=template&id=a2bf5978&scoped=true&"
import script from "./resourcePoolSystem.vue?vue&type=script&lang=js&"
export * from "./resourcePoolSystem.vue?vue&type=script&lang=js&"
import style0 from "./resourcePoolSystem.vue?vue&type=style&index=0&id=a2bf5978&prod&scoped=true&lang=css&"
import style1 from "./resourcePoolSystem.vue?vue&type=style&index=1&id=a2bf5978&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf5978",
  null
  
)

export default component.exports